export default __webpack_public_path__ + "static/bannerPubli-PY-782fd4693663aa4432f5aa589e8b21ef.png";